import {
  auth,
  GoogleAuthProvider,
  signInWithPopup,
} from '../config/firebase'

export async function signInWithGoogle() {
  const provider = new GoogleAuthProvider()
  const result = await signInWithPopup(auth, provider)
  return result
}
